@if (control().dirty && control().validator) { @if (this.control().valid) {
<fa-icon class="form-control-feedback" [icon]="['fas', 'check']" />
} @else {
<fa-icon class="form-control-feedback" [icon]="['fas', 'times']" />
} @for (error of errors | slice : 0 : 1; track error) {
<small class="validation-message">
  {{ error | translate }}
</small>
} }
